import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button/Button";
import {Translate} from "../../../config/Translate";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import IconButton from "@material-ui/core/IconButton/IconButton";
import AddBox from "@material-ui/icons/AddBox";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import {currencySymbol} from "../../../config/values";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import PaymentIcon from '@material-ui/icons/Payment';
import {defaultVariabls} from "../../../config";
class AddFile extends React.Component {
    state = {
        open:false,
        error:'',
        amount:!!this.props.amount ? this.props.amount : 100000,
        amountR:!!this.props.amount ? this.props.amount : 100000,
    };
    handleChange(e){
        let target = e.target;
        let amountR = target.value.replace(/,/ig, '');
        let error = "";
        this.setState({
            error,
            amountR,
            amount: target.value
        });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        if(this.state.amountR > 1000){
            window.open(`${defaultVariabls.website}/wallet/charge/${this.state.amountR}${!!this.props.redirect ? "?r="+this.props.redirect : ""}`,'_self')
        }else{
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });

            this.setState({
                error: Translate.wrongPrice,
                SubmitLoading:false,
            })
        }
    }
    classes = this.props.classes;
    render(){
        let {error,open,amountR} = this.state;
        let {purchase} = this.props;
        return(
            <>
                {
                    purchase ?
                        <Button
                            variant={!!this.props.variant ? this.props.variant :"contained"}
                            color="secondary"
                            style={this.props.style}
                            startIcon={<AddBox/>}
                            onClick={() => this.setState({open: !this.state.open})}
                        >
                            {Translate.depositMoney}
                        </Button>
                        :
                        <>
                            {
                                this.props.width !== "xs" ?
                                    <Button
                                        variant={!!this.props.variant ? this.props.variant :"contained"}
                                        color="secondary"
                                        style={this.props.style}
                                        startIcon={<AddBox/>}
                                        onClick={() => this.setState({open: !this.state.open})}
                                    >
                                        {Translate.depositMoney}
                                    </Button>
                                    :
                                    <IconButton color="secondary" onClick={() => this.setState({open: !this.state.open})}>
                                        <AddBox/>
                                    </IconButton>
                            }
                        </>
                }

                <Dialog fullWidth maxWidth="sm" open={open} onClose={() => this.setState({open: !this.state.open})} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{Translate.depositMoney}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {Translate.depositMoneyDescription}
                        </DialogContentText>
                        <CurrencyTextField
                            variant="outlined"
                            required
                            fullWidth
                            margin="normal"
                            currencySymbol={currencySymbol}
                            decimalPlaces={0}
                            value={amountR}
                            id="amount"
                            label={Translate.amount}
                            name="amount"
                            onChange={this.handleChange.bind(this)}
                            error = {!!error}
                            helperText={error}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSubmit.bind(this)} variant={"contained"} color="primary" startIcon={<PaymentIcon/>}>
                            {Translate.purchase}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

export default withWidth()(withSnackbar(withStyles(Styles)(AddFile)));